import React from 'react';
import {CustomThemeContext} from '../context/custom-theme-context';

export const useIdMirrorTheme = () => {
  const context = React.useContext(CustomThemeContext);

  if (!context) {
    throw new Error(
      'useIdMirrorTheme debe usarse dentro de un CustomThemeProvider',
    );
  }

  return context;
};
